<template>
    <div id="appClientReports">
        <div class="c-subheader">
            <h5 id="headerClient"></h5>
            <div class="noContractAvailabile col-sm-4" v-if="!anyContract && isLoaded">
                <label style="color: #f78764;">No contracts have been created for this client. Please enter a contract first to access the report.</label>
            </div>
        </div>
        <ejs-tab id="element" ref=clientReportTabs v-if="anyContract">
            <e-tabitems>
                <e-tabitem :header='headerText0' :content='PositionReportTemplate'></e-tabitem>
                <e-tabitem :header='headerText1' :content='ContractsOverviewTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='HedgingReport'></e-tabitem>
                <e-tabitem :header='headerText5' :content='ClientAlertsReportTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
        <ejs-tab id="elementDisabled" ref=clientReportTabs v-if="!anyContract">
            <e-tabitems>
                <e-tabitem :header='headerText0' :disabled="isDisabled"></e-tabitem>
                <e-tabitem :header='headerText1' :disabled="isDisabled"></e-tabitem>
                <e-tabitem :header='headerText4' :disabled="isDisabled"></e-tabitem>
                <e-tabitem :header='headerText5' :disabled="isDisabled"></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import PositionReport from '@/views/templates/ClientPositionReportTemplate.vue';
    import HedgingReport from '@/views/templates/ClientHedgingReport.vue';
    import ClientAlertsReportTemplate from '@/views/templates/ClientAlertsReportTemplate.vue';
    import ContractsOverviewReport from '@/views/templates/ContractsOverviewReport.vue';
    import urls from '../../common/urls';
    import apis from '../../common/network';

    Vue.use(TabPlugin);
    export default {
        name: 'ClientReportTabs',
        created() {
            this.$store.commit('setReportsClientId', this.$route.params.clientId);
            this.fetchData(this.$route.params.clientId);
            this.fetchClientNameAndContracts(this.$route.params.clientId);
        },
        data: function () {
            return {
                headerText0: { text: 'Position Summary' },
                headerText4: { text: 'Hedging Overview' },
                headerText1: { text: 'Contracts Overview' },
                position: { X: 'Right', Y: 'Bottom' },
                propsData: null,
                deadline: 0,
                status: 0,
                hit: 0,
                AlertsCount:0,
                isDisabled: false,
                anyContract: false,
                isLoaded: false,
                PositionReportTemplate: function () {
                    return {
                        template: {
                            extends: PositionReport
                        }
                    };
                },
               ContractsOverviewTemplate: function () {
                    return {
                        template: {
                            extends: ContractsOverviewReport
                        }
                    };
                },
                HedgingReport: function () {
                    return {
                        template: {
                            extends: HedgingReport
                        }
                    };
                }, 
                ClientAlertsReportTemplate: function () {
                    return {
                        template: {
                            extends: ClientAlertsReportTemplate
                        }
                    }
                },
            }
        },
         methods: {
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?clientId=${id}`).then(it => {
                    this.deadline = it.data.deadline;
                    this.status = it.data.status;
                    this.hit = it.data.hit;
                    this.AlertsCount = this.hit + this.deadline + this.status;
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },
            fetchClientNameAndContracts(id) {
                apis.protectedApi.get(`client/getClientName?clientId=${id}`)
                    .then(response => {

                        this.clientName = response.data.clientName;
                        document.getElementById('headerClient').textContent = this.clientName;

                    }).catch(response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );
                apis.protectedApi(`utils/ClientHasContracts?clientId=${id}`)
                    .then(response => {
                        this.anyContract = response.data;
                        this.isDisabled = response.data == true ? false : true;
                        this.isLoaded = true;
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
         },
       computed: {
            headerText5() {
               return { text: "Alerts (" + this.AlertsCount + ")" };
           },
       },
    }
</script>

<style scoped>
</style>

<style>
    #headerClient {
        color: #8a93a2;
        margin-top: 10px;
        margin-left: 11px;
    }
    .noContractAvailabile {
        color: #f78764;
        margin-top: 10px;
        margin-left: 25px;
    }
</style>